import { getConfluenceContentIdFromUrl } from './getConfluenceContentIdFromUrl';

/**
 * This is a temporary helper function to get the current page ID from the current URL.
 * Eventually this is come from the backend.
 */
export const getCurrentPageId = (): string | undefined => {
	// Extracts the numeric page ID from the current Confluence page URL.
	// Handles both view and edit URL formats:
	//   View: https://<site>.atlassian.net/wiki/spaces/<spaceKey>/pages/<pageId>/<page-title>
	//   Edit: https://<site>.atlassian.net/wiki/spaces/<spaceKey>/pages/edit-v2/<pageId>
	return getConfluenceContentIdFromUrl(window?.location.href);
};
